import { StandardReducerImpl } from 'reducers/standard.reducer';
const standardReducerImpl = new StandardReducerImpl<any>('clearEntities', {}, 'clearEntities');
export const clearEntities = standardReducerImpl.clearEntities;